import * as React from 'react';
import { withPrefix } from 'gatsby';

export interface ImageProps extends React.HTMLAttributes<HTMLImageElement> {
  src?: string;
}

const extractClassNames = (url: string) => {
  const parts = url.split('#');
  if (parts.length === 2) {
    const classNames = parts[1].split(',');
    return classNames.map((className) => className.trim());
  }
  return [];
};

export const Image = ({ src, ...props }: ImageProps) => {
  if (!src) return null;

  const classNames = extractClassNames(src);
  const imageUrl = src.split('#')[0];

  return (
    <img
      {...props}
      src={withPrefix(imageUrl)}
      className={classNames?.length ? classNames.join(' ') : undefined}
    />
  );
};
